export default "__VITE_ASSET__db2ba469__"